const TestPage = () => {
  return (
    <div>
      HIII
      {[{ text: 'Hi', name: 'ss', s: 'aa' }].map(({ name, text, s }) => (
        <>
          <>{text}</>
          <>{name}</>
          {/* IT IS ERROR */}
          <>{s.map(s => s)}</>
        </>
      ))}
    </div>
  );
};

export default TestPage;
